import { ToTagPropsFn } from '../../../types'
import { NonUserEmailTagNonUserEmail } from '../types'

/**
 * a callback to transform a Non User Email to the tags prop of a CIMSTags component
 */
export const toNonUserEmailTagProps: ToTagPropsFn<
  NonUserEmailTagNonUserEmail
> = ({ address, label }) => ({
  text: label ?? address,
  tooltip: !!label ? address : undefined,
})
